module.exports = "/images/vendor/flag-icon-css/flags/1x1/tr.svg?ce2e2e8e0650cfed7548dd59c2c184c5";